import React from 'react'
import { object, number } from 'prop-types'

const termDefine = {
  sale: {
    tableType: '銷貨',
    accountAction: '收',
    priceName: '售價',
    recipientAction: '送',
    recipientTitle: '客戶名稱',
    recipientPhoneTitle: '客戶電話',
    referTitle: '廠商/維修單號',
  },
  purchase: {
    tableType: '進貨',
    accountAction: '付',
    priceName: '進價',
    recipientAction: '發',
    recipientTitle: '出貨單位',
    recipientPhoneTitle: '電話',
    referTitle: '廠商銷貨單號',
  },
  saleReturn: {
    tableType: '銷貨退回',
    accountAction: '退',
    priceName: '回收價',
    recipientAction: '發',
    recipientTitle: '退貨單位',
    recipientPhoneTitle: '電話',
    referTitle: '廠商/維修單號',
  },
  purchaseReturn: {
    tableType: '進貨退回',
    accountAction: '退',
    priceName: '退回價',
    recipientAction: '發',
    recipientTitle: '供貨單位',
    recipientPhoneTitle: '電話',
    referTitle: '廠商銷貨退回單號',
  },
}

function StatementHeader ({ style, value }) {
  return (
    <table className={style['header-region']}>
      <tbody>
        <tr>
          <td className={style['header-left']}>
            <div data-name="寄件單位">
              <div className={style['print-data']}>中天眼鏡-{value.sender}</div>
            </div>
          </td>
          <td className={style['header-mid']}>
            <div data-name="單據類型">
              <div className={style['print-data']}>
              {termDefine[value.statementType].tableType}單
              </div>
            </div>
          </td>
          <td className={style['header-right-top']}>
            <div data-name="單據編號">
              <div className={style['print-data']}>{value.key}</div>
            </div>
          </td>
        </tr>
        <tr>
          <td className={style['header-left']}>
            <div data-name="客戶地址">
              <div className={style['print-data']}>{value.senderAddress}</div>
            </div>
          </td>
          <td colSpan={2} rowSpan={2} className={style['header-right-bottom']}>
            <div data-name="單據條碼">
              <div className={style['print-data']}>*{value.key}*</div>
            </div>
          </td>
        </tr>
        <tr>
          <td className={style['header-left']}>
            <div data-name="客戶電話">
              <div className={style['print-data']}>
                TEL: {value.senderPhone} FAX: {value.senderFAX}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

StatementHeader.propTypes = {
  style: object,
  value: object,
}

function SheetTitle ({ style, value, pageNum }) {
  return (
    <table className={style['sheet-title']}>
      <tbody>
        <tr>
          <td className={style['title-left']}>
          </td>
          <td className={style['title-right']}>
            <div data-name="廠商/維修單號">
              <div className={style['print-data']}>
                {termDefine[value.statementType].referTitle}:{value.repairNo}
              </div>
            </div>
          </td>
          <td className={style['page-num']}>
            第{pageNum}頁
          </td>
        </tr>
        <tr>
          <td className={style['title-left']}>
            <div data-name="客戶名稱">
              <div className={style['print-data']}>
                {termDefine[value.statementType].recipientTitle}:{value.recipient}
              </div>
            </div>
          </td>
          <td className={style['title-right']}>
            <div data-name="銷貨日期">
              <div className={style['print-data']}>
                {termDefine[value.statementType].tableType}日期:{value.sendDate}
              </div>
            </div>
          </td>
          <td></td>
        </tr>
        <tr>
          <td className={style['title-left']}>
            <div data-name="客戶電話">
              <div className={style['print-data']}>
                {termDefine[value.statementType].recipientPhoneTitle}:{value.recipientPhone}</div>
            </div>
          </td>
          <td className={style['title-right']}>
            <div data-name="結帳日期">
              <div className={style['print-data']}>結帳日期:{value.paymentDate}</div>
            </div>
          </td>
          <td></td>
        </tr>
        <tr>
          <td className={style['title-left']}>
            <div data-name="送貨地址">
              <div className={style['print-data']}>
                {termDefine[value.statementType].recipientAction}貨地址:{value.recipientAddress}
              </div>
            </div>
          </td>
          <td className={style['title-right']}>
            <div data-name="統一編號">
              <div className={style['print-data']}>統一編號:{value.CID}</div>
            </div>
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
  )
}

SheetTitle.propTypes = {
  style: object,
  value: object,
  pageNum: number,
}

function ItemListHeader ({ style, value }) {
  return (
    <table className={style['list-header']}>
      <tbody>
        <tr className={style['print-data']}>
          <td data-name="項目">項目</td>
          <td data-name="條碼">條碼</td>
          <td data-name="品名規格">品名規格</td>
          <td data-name="數量">數量</td>
          <td data-name="單位">單位</td>
          <td data-name="售價">{termDefine[value.statementType].priceName}</td>
          <td data-name="小計">小計</td>
          <td data-name="留白"></td>
          <td data-name="備註">備註</td>
        </tr>
      </tbody>
    </table>
  )
}

ItemListHeader.propTypes = {
  style: object,
  value: object,
}

function PageFooter ({ style }) {
  return (
    <table className={style['page-footer']}>
      <tbody>
        <tr className={style['print-data']}>
          <td data-name="審核">審核:</td>
          <td data-name="經辦">經辦:</td>
          <td data-name="會計">會計:</td>
          <td data-name="業務">業務:</td>
          <td data-name="簽收">簽收:</td>
        </tr>
      </tbody>
    </table>
  )
}

PageFooter.propTypes = {
  style: object,
}

function PageHeader ({ style, value, pageNum }) {
  return (
    <table className={style['page-header']}>
      <tbody>
        <tr className={style['print-data']}>
          <td data-name="單號">{termDefine[value.statementType].tableType}單號:{value.key}</td>
          <td data-name="頁碼">第{pageNum}頁</td>
        </tr>
        <tr className={style['print-data']}>
          <td data-name="單號"></td>
          <td data-name="頁碼"></td>
        </tr>
      </tbody>
    </table>
  )
}

PageHeader.propTypes = {
  style: object,
  value: object,
  pageNum: number,
}

function StatementEnd ({ style, value }) {
  if (value.items && ((value.items.length + 7) % 22 > 17)) {
    const pageNum = Math.floor((value.items.length + 7) / 22) + 2
    return (
    <div>
      <PageFooter {...{ style }} />
      <div className={style['page-break']} />
      <PageHeader {...{ style, value, pageNum }} />
      <table className={style['statement-end']}>
        <tbody>
          <tr className={style['print-data']}>
            <td data-name="左">{value.itemNumCount}</td>
            <td data-name="右標題">未稅合計</td>
            <td data-name="右值">{value.beforeTax}</td>
          </tr>
          <tr className={style['print-data']}>
            <td data-name="左">附註:{value.sheetNotice}</td>
            <td data-name="右標題">稅額:</td>
            <td data-name="右值">{value.tax}</td>
          </tr>
          <tr className={style['print-data']}>
            <td data-name="左"></td>
            <td data-name="右標題">含稅合計:</td>
            <td data-name="右值">{value.totalPrice}</td>
          </tr>
          <tr className={style['print-data']}>
            <td data-name="左"></td>
            <td data-name="右標題">折讓金額:</td>
            <td data-name="右值">{value.discount}</td>
          </tr>
        </tbody>
      </table>
      <table className={style['statement-end-total']}>
        <tbody>
          <tr className={style['print-data']}>
            <td data-name="左"></td>
            <td data-name="右標題">應{termDefine[value.statementType].accountAction}總計:</td>
            <td data-name="右值">{value.receivable}</td>
          </tr>
        </tbody>
      </table>
    </div>
    )
  }
  return (
  <div>
    <table className={style['statement-end']}>
      <tbody>
        <tr className={style['print-data']}>
          <td data-name="左">{value.itemNumCount}</td>
          <td data-name="右標題">未稅合計</td>
          <td data-name="右值">{value.beforeTax}</td>
        </tr>
        <tr className={style['print-data']}>
          <td data-name="左">附註:{value.sheetNotice}</td>
          <td data-name="右標題">稅額:</td>
          <td data-name="右值">{value.tax}</td>
        </tr>
        <tr className={style['print-data']}>
          <td data-name="左"></td>
          <td data-name="右標題">含稅合計:</td>
          <td data-name="右值">{value.totalPrice}</td>
        </tr>
        <tr className={style['print-data']}>
          <td data-name="左"></td>
          <td data-name="右標題">折讓金額:</td>
          <td data-name="右值">{value.discount}</td>
        </tr>
      </tbody>
    </table>
    <table className={style['statement-end-total']}>
      <tbody>
        <tr className={style['print-data']}>
          <td data-name="左"></td>
          <td data-name="右標題">應{termDefine[value.statementType].accountAction}總計:</td>
          <td data-name="右值">{value.receivable}</td>
        </tr>
      </tbody>
    </table>
  </div>
  )
}

StatementEnd.propTypes = {
  style: object,
  value: object,
}


function ItemList ({ style, value }) {
  const LINE_LIMIT = 26
  const NEXT_PAGE_LINE_INIT = 6
  let pageNum = 1
  let currentLineNum = 13
  return (
    <div>
    <ItemListHeader {...{ style, value }} />
    {value.items && value.items.map((item, i) => {
      if (item) {
        if (currentLineNum > LINE_LIMIT) {
          currentLineNum = NEXT_PAGE_LINE_INIT
          pageNum++
          return (
            <div key={i}>
            <table className={style.items}>
            <tbody>
            <tr className={style['print-data']}>
              <td data-name="項目">{i + 1}</td>
              <td data-name="條碼">{item.key}</td>
              <td data-name="品名規格">{item.name}</td>
              <td data-name="數量">{item.qty}</td>
              <td data-name="單位">{item.unit}</td>
              <td data-name="售價">{item.salePrice}</td>
              <td data-name="小計">{item.subtotal}</td>
              <td data-name="留白"></td>
              <td data-name="備註">{item.note}</td>
            </tr>
            </tbody>
            </table>
            <PageFooter {...{ style }} />
            <div className={style['page-break']} />
            <PageHeader {...{ style, value, pageNum }} />
            </div>
          )
        } else if (currentLineNum === NEXT_PAGE_LINE_INIT) {
          currentLineNum++
          return (
          <div key={i}>
            <ItemListHeader {...{ style, value }} />
            <table className={style.items}>
            <tbody>
            <tr className={style['print-data']}>
              <td data-name="項目">{i + 1}</td>
              <td data-name="條碼">{item.key}</td>
              <td data-name="品名規格">{item.name}</td>
              <td data-name="數量">{item.qty}</td>
              <td data-name="單位">{item.unit}</td>
              <td data-name="售價">{item.salePrice}</td>
              <td data-name="小計">{item.subtotal}</td>
              <td data-name="留白"></td>
              <td data-name="備註">{item.note}</td>
            </tr>
            </tbody>
            </table>
          </div>
          )
        }
        currentLineNum++
        return (
          <div key={i}>
            <table className={style.items}>
            <tbody>
            <tr className={style['print-data']}>
              <td data-name="項目">{i + 1}</td>
              <td data-name="條碼">{item.key}</td>
              <td data-name="品名規格">{item.name}</td>
              <td data-name="數量">{item.qty}</td>
              <td data-name="單位">{item.unit}</td>
              <td data-name="售價">{item.salePrice}</td>
              <td data-name="小計">{item.subtotal}</td>
              <td data-name="留白"></td>
              <td data-name="備註">{item.note}</td>
            </tr>
            </tbody>
            </table>
          </div>
      )}
      return null
    })}
    </div>
  )
}

ItemList.propTypes = {
  style: object,
  value: object,
}

function Print ({ style, value }) {
  if (value.items) {
    return (
      <div className={style.print}>
        <div className={style.statement}>
          <StatementHeader {...{ style, value }} />
          <SheetTitle {...{ style, value, pageNum: 1 }} />
          <ItemList {...{ style, value }} />
          <StatementEnd {...{ style, value }} />
          <PageFooter {...{ style }} />
        </div>
      </div>
  )
  }
}

Print.propTypes = {
  style: object.isRequired,
  value: object,
}

export default Print



// WEBPACK FOOTER //
// ./src/components/Statement/Print.jsx